import { TLoginAttemptReq } from "@sharedTypes/req.type";
import { TLoginAttemptRes } from "@sharedTypes/res.type";

import missingParametersError from "api/Error";
import axios from "axios";

export async function LoginAttempt(email: string, password: string) {
  const apiUrl = "/auth/loginattempt";

  const body: TLoginAttemptReq = {
    email,
    password,
  };

  for (const [key, param] of Object.entries(body)) {
    if (param === undefined) throw missingParametersError(key);
  }

  const data: TLoginAttemptRes = await axios
    .post(apiUrl, body)
    .then((res) => res.data)
    .catch((err) => {
      console.log(err);
      throw err.response.data;
    });

  return data;
}
